const interventionOptionsByCategory: any = {
  development: [
    { value: 'assumption', label: 'Assumption (absolute values)' },
    { value: 'assumption-growth', label: 'Assumption (growth rate)' },
    { value: 'assumption-percentage', label: 'Percentage change' },
    {
      value: 'assumption-derived-dwellings',
      label: 'Derived dwellings from population',
    },
  ],
  energy: [
    { value: 'building-efficiency', label: 'Building efficiency' },
    { value: 'grid-decarbonisation', label: 'Grid decarbonisation' },
    {
      value: 'grid-decarbonisation-percentage',
      label: 'Grid decarbonisation (percentage)',
    },
    { value: 'building-electrification', label: 'Building electrification' },
    { value: 'new-building-standards', label: 'New building standards' },
  ],
  transport: [
    {
      value: 'mode-shift-to-public-transport',
      label: 'Mode shift to public transport',
    },
    {
      value: 'mode-shift-to-active-transport',
      label: 'Mode shift to active transport',
    },
    { value: 'electric-vehicle-takeup', label: 'Electric vehicle takeup' },
    {
      value: 'road-to-rail-freight-mode-shift',
      label: 'Road to rail freight mode shift',
    },
    { value: 'rail-freight-efficiency', label: 'Rail freight efficiency' },
    { value: 'air-transport-efficiency', label: 'Air transport efficiency' },
  ],
  waste: [
    { value: 'waste-reduction', label: 'Waste reduction' },
    {
      value: 'waste-diversion-from-landfill',
      label: 'Diversion from landfill',
    },
    { value: 'waste-treatment', label: 'Waste treatment' },
    { value: 'wastewater-treatment', label: 'Wastewater treatment' },
  ],
  ippu: [
    { value: 'industrial-processes', label: 'Industrial-processes reduction' },
    { value: 'product-use', label: 'Product-use reduction' },
  ],
  agriculture: [
    { value: 'livestock', label: 'Livestock reduction' },
    { value: 'horticulture', label: 'Horticulture reduction' },
  ],
  forestry: [{ value: 'exotic-forest-change', label: 'Exotic forest change' }],
};

const interventionOptions = Object.entries(
  interventionOptionsByCategory,
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
).flatMap(([_, v]) => v);

export { interventionOptionsByCategory, interventionOptions };
